import { IdEventSoundCore } from "./sound/IdEventSoundCore";
import { utilSound } from "./sound/utilSound";
var UtilButton = /** @class */ (function () {
    function UtilButton() {
        this.onClickWithSound = function (onClick, clickSound) {
            if (onClick == undefined) {
                return;
            }
            utilSound.event(clickSound || IdEventSoundCore.ButtonClick);
            onClick();
        };
    }
    return UtilButton;
}());
export var utilButton = new UtilButton();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilButton.ts
// module id = 111
// module chunks = 3